import React from "react"
import { makeStyles, Container, Typography } from "@material-ui/core"
import { Link } from "react-router-dom"

import frontierLogo from "../../../images/logos/logo-frontier-research.png"
import mediumIcon from "../../../images/icons/icon-medium.svg"
import facebookIcon from "../../../images/icons/icon-facebook.svg"
import linkedinIcon from "../../../images/icons/icon-linkedin.svg"
import instagramIcon from "../../../images/icons/icon-instagram.svg"

import { FooterStyles } from "../../styles"

const useStyles = makeStyles(theme => ({ ...FooterStyles(theme) }))

export default function Footer () {
  const classes = useStyles()
  
  const SocialIcon = ({ href, src, alt }) => (
    <a href={href} target="_blank" rel="noopener noreferrer">
      <img className={classes.socialIcon} src={src} alt={alt} />
    </a>
  )

  const socialProfiles = [
    { href: "https://medium.com/frontier-research", src: mediumIcon, alt: "Medium Logo" },
    { href: "https://www.facebook.com/FrontierResearch/", src: facebookIcon, alt: "Facebook Logo" },
    { href: "https://www.linkedin.com/company/frontier-i/", src: linkedinIcon, alt: "LinkedIn Logo" },
    { href: "https://www.instagram.com/frontier.research/", src: instagramIcon, alt: "Instagram Logo" }
  ]

  return (
    <div className={classes.root}>
      <Container className={classes.container} maxWidth="lg">
        <img
          className={classes.footerLogo}
          src={frontierLogo}
          alt="Frontier Research Logo"
        />

        <Link
          className={classes.linkWrapper}
          to="/privacy-policy"
        >
          <Typography color="primary">Privacy Policy</Typography>
        </Link>

        <div className={classes.containerRight}>
          <div>
            {socialProfiles.map(({ href, src, alt }, index) => <SocialIcon key={index} href={href} src={src} alt={alt} />)}
          </div>
          <Typography className={classes.copyrightText}>
            &copy;
            {` ${new Date().getFullYear()} Frontier Research (Pvt) Ltd.`}
          </Typography>
        </div>
      </Container>
    </div>
  )
}
